import reducer from './receipt.reducer';
import * as constant from './receipt.constant';
import * as action from './receipt.action';
import * as selector from './receipt.selector';
import saga from './receipt.saga';
import initialState from './receipt.initialState';

export default {
  reducer,
  action,
  constant,
  selector,
  name: constant.NAME,
  saga,
  initialState,
};
